import React, { useState } from "react";
import { Heart, ThumbsUp, ThumbsDown, Laugh } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const TYPES = [
  { id: "heart", icon: Heart, label: "پسند", color: "text-rose-600", activeBg: "bg-rose-500" },
  { id: "agree", icon: ThumbsUp, label: "متفق", color: "text-emerald-700", activeBg: "bg-emerald-600" },
  { id: "disagree", icon: ThumbsDown, label: "غیر متفق", color: "text-slate-600", activeBg: "bg-slate-600" },
  { id: "laugh", icon: Laugh, label: "ہنسی", color: "text-amber-600", activeBg: "bg-amber-500" },
];

export default function Reactions({ postId, initialSummary, initialMine }) {
  const { user } = useAuth();
  const [summary, setSummary] = useState(initialSummary || { heart: 0, agree: 0, disagree: 0, laugh: 0 });
  const [mine, setMine] = useState(initialMine || null);

  const toggle = async (type) => {
    if (!user) { toast.error("لاگ اِن کریں"); return; }
    try {
      const { data } = await api.post(`/posts/${postId}/react`, { type });
      setSummary(data.summary);
      setMine(data.my_reaction);
    } catch {
      toast.error("رد عمل درج نہیں ہو سکا");
    }
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`reactions-${postId}`}>
      {TYPES.map((t) => {
        const active = mine === t.id;
        const count = summary[t.id] || 0;
        const Icon = t.icon;
        return (
          <Button
            key={t.id}
            size="sm"
            variant={active ? "default" : "outline"}
            onClick={() => toggle(t.id)}
            title={t.label}
            data-testid={`react-${t.id}-${postId}`}
            className={`gap-1.5 h-8 font-eng ${active ? `${t.activeBg} hover:${t.activeBg}` : ""}`}
          >
            <Icon size={14} className={active ? "fill-current text-white" : t.color} />
            <span className={active ? "text-white" : ""}>{count}</span>
          </Button>
        );
      })}
    </div>
  );
}
